import { LazyLoad } from 'features/common/ui/LazyLoad'
import AuthenticatedRoute from 'app/ui/AuthenticatedRoute'
import { lazy } from 'app/lazy'

const MapsPage = lazy(() => import('./MapsPage'))

const routes = {
  path: 'maps',
  element: (
    <LazyLoad>
      <AuthenticatedRoute element={<MapsPage />} allowGuestAccess />
    </LazyLoad>
  )
}
export default routes
